import _ from 'lodash'

export const getNewValue = (newValue, prevValue) => (_.isFunction(newValue) ? newValue(prevValue) : newValue)

export const removeKey = (obj, key) => {
  const newObj = { ...obj }
  delete newObj[key]
  return newObj
}
